export enum organizationStatuses {
    Active = 1,
    Blocked,
}
